import { Breadcrumbs } from '../../../AbstractElements'
import { ButtonGroup, Buttons } from '../../../Constant'
import { Container, Row } from 'reactstrap'
import BasicButtonGroup from './BasicButtonGroup'
import EdgesButtonGroup from './EdgesButtonGroup'
import FlatButtonGroup from './FlatButtonGroup'
import LargeButtonGroup from './LargeButtonGroup'
import LargeEdgesButtonGroup from './LargeEdgesButtonGroup'
import OutlineButtonGroup from './OutlineButtonGroup'
import OutlineEdgesButton from './OutlineEdgesButton'
import OutlineFlatButton from './OutlineFlatButton'
import RadioButtonGroup from './RadioButtonGroup'
import CheckBoxButtonGroup from './CheckBoxButtonGroup'
import Nesting from './Nesting'
import Vertical from './Vertical'
import OutlineCustomButtonGroup from './OutlineCustomButtonGroup'
import OutlineCustomButtonGroups from './OutlineCustomButtonGroups'

const ButtonGroupContainer = () => {
  return (
    <>
    <Breadcrumbs pageTitle={ButtonGroup} parent={Buttons} title={ButtonGroup} />
    <Container fluid>
      <Row>
        <BasicButtonGroup/>
        <EdgesButtonGroup/>
        <FlatButtonGroup/>
        <LargeButtonGroup/>
        <LargeEdgesButtonGroup/>
        <OutlineCustomButtonGroup/>
        <OutlineCustomButtonGroups/>
        <OutlineButtonGroup/>
        <OutlineEdgesButton/>
        <OutlineFlatButton/>
        <RadioButtonGroup/>
        <CheckBoxButtonGroup/>
        <Nesting/>
        <Vertical/>
      </Row>
    </Container>
    </>
  )
}

export default ButtonGroupContainer